import React from 'react';
import useStripeInvoice from '../hooks/useStripeInvoice';

const Invoice = ({ managingAccountId, clientAccountId, invoiceId, invoiceNumber }) => {
  const { redirectToStripeHostedInvoiceUrl } = useStripeInvoice();

  return (
    <div
      className="invoice-link"
      onClick={() => {
        redirectToStripeHostedInvoiceUrl(managingAccountId, clientAccountId, invoiceId);
      }}
    >
      {invoiceNumber}
    </div>
  );
};

export default Invoice;
